import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const Hero = () => {
  return <Section className="bg-[#060f1c] pt-4 md:pt-16 pb-6 md:pb-12" data-id="element-312">
      <div className="max-w-4xl mx-auto text-center space-y-3 md:space-y-8" data-id="element-313">
        <FadeIn data-id="element-314">
          <div className="space-y-2 md:space-y-6" data-id="element-315">
            {/* Changed container to inline-flex, added gap, new BG, and modified texts */}
            <div className="inline-flex items-center gap-1.5 bg-white/10 text-white font-bold px-3 py-1 rounded-full md:mb-2 text-[11px] md:text-[14px] border border-white/10" data-id="element-316">
              <span className="text-base" data-id="element-317">⚽</span>
              <span className="text-brandOrange" data-id="element-318">EL ARSENAL DEL PROFE™</span>
            </div>
            {/* Updated h1 with new font size, layout, and styling */}
            <h1 className="font-extrabold text-white text-[30px] md:text-5xl lg:text-6xl leading-[1.1] tracking-tight px-2" data-id="element-319">
              Todo tu año de
              <br data-id="element-320" />
              <span className="text-brandOrange" data-id="element-321">Educación Física.</span>
              <br data-id="element-322" />
              <span className="text-white" data-id="element-323">Listo. Desde hoy.</span>
            </h1>
            {/* Changed paragraph styling to smaller font, different color, and padding */}
            <p className="text-gray-300 text-[13px] md:text-base font-medium px-3 leading-snug" data-id="element-324">
              Sesiones · Juegos · Clases listas · Primaria · Secundaria · Sin
              materiales
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-325">
          <a href="#pricing" className="block cursor-pointer" data-id="element-326">
            <img src="https://cdn.magicpatterns.com/uploads/m24tX2QfVjgY5cQRyyupXG/quiero_que_me_202604132324_-_Editado.png" alt="El Arsenal del Profe — Mockup del MegaPack" width={1024} height={1024} loading="eager" decoding="async"
          // @ts-ignore
          fetchpriority="high" className="block w-full max-w-[260px] md:max-w-xl mx-auto h-auto object-contain hover:scale-[1.02] transition-transform duration-300 drop-shadow-2xl" data-id="element-327" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-328">
          <div className="max-w-2xl mx-auto space-y-3 md:space-y-6" data-id="element-329">
            {/* Desktop chips */}
            <div className="hidden md:flex flex-wrap gap-2 flex-row items-end justify-center" data-id="element-330">
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm pt-[7px] pb-[7px]" data-id="element-331">
                <span className="text-base" data-id="element-332">📄</span> 100% PDF
              </span>
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm" data-id="element-333">
                <span className="text-base" data-id="element-334">⚡</span> Acceso en 5 minutos
              </span>
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm" data-id="element-335">
                <span className="text-base" data-id="element-336">🇦🇷</span> Primaria + Secundaria
              </span>
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm" data-id="element-337">
                <span className="text-base" data-id="element-338">🎯</span> Sin materiales + Con
                materiales
              </span>
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm" data-id="element-339">
                <span className="text-base" data-id="element-340">📚</span> 120+ actividades listas
              </span>
            </div>

            {/* Mobile chips */}
            <div className="flex md:hidden flex-nowrap gap-1.5 justify-center items-center" data-id="element-341">
              <span className="bg-white/10 text-white px-2.5 py-1.5 rounded-full text-[11px] font-semibold inline-flex items-center gap-1 border border-white/15 whitespace-nowrap shrink-0" data-id="element-342">
                <span className="text-xs" data-id="element-343">📄</span> PDF
              </span>
              <span className="bg-white/10 text-white px-2.5 py-1.5 rounded-full text-[11px] font-semibold inline-flex items-center gap-1 border border-white/15 whitespace-nowrap shrink-0" data-id="element-344">
                <span className="text-xs text-brandOrange" data-id="element-345">⚡</span> Acceso
                Inmediato
              </span>
              <span className="bg-white/10 text-white px-2.5 py-1.5 rounded-full text-[11px] font-semibold inline-flex items-center gap-1 border border-white/15 whitespace-nowrap shrink-0" data-id="element-346">
                <span className="text-xs" data-id="element-347">🇦🇷</span> Argentina
              </span>
            </div>

            {/* Call-to-action button and info */}
            <div className="space-y-2.5 md:space-y-3 md:pt-2" data-id="element-348">
              {/* Updated button styles for size, font, and border-radius */}
              <CTAButton href="#pricing" fullWidth className="text-base md:text-xl py-4 md:py-5 animate-glow-button !rounded-2xl md:!rounded-full font-black tracking-wide" trackEvent={{
              name: 'Lead',
              params: {
                content_name: 'Hero CTA — Quiero el MegaPack',
                content_category: 'engagement'
              }
            }} data-id="element-349">
                💪 → QUIERO EL MEGAPACK AHORA
              </CTAButton>

              {/* Changed pricing info layout and styles for baseline alignment, icon size, and gaps */}
              <div className="flex flex-wrap items-center justify-center gap-2.5 md:gap-4 text-[10px] md:text-xs text-gray-400 font-medium pt-1" data-id="element-350">
                <span className="flex items-center gap-1" data-id="element-351">
                  <ShieldCheck size={13} className="text-green-500" data-id="element-352" /> Garantía
                  30 días
                </span>
                <span className="flex items-center gap-1" data-id="element-353">
                  <Lock size={13} className="text-gray-400" data-id="element-354" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-355">
                  <CreditCard size={13} className="text-blue-400" data-id="element-356" />
                  <span className="md:hidden" data-id="element-357">Tarjetas | Mercado Pago</span>
                  <span className="hidden md:inline" data-id="element-358">
                    Mercado Pago | Tarjeta | Transferencia
                  </span>
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
};
export const SocialProof = () => {
  return <div className="bg-[#070f1e] border-y border-white/10 py-6" data-id="element-359">
      <div className="max-w-6xl mx-auto px-4" data-id="element-360">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-white/10" data-id="element-361">
          <FadeIn delay={0.1} data-id="element-362">
            <div className="text-2xl md:text-3xl font-bold text-brandOrange mb-0.5" data-id="element-363">
              +500
            </div>
            <div className="text-xs text-gray-300 font-medium" data-id="element-364">
              profes confían
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-365">
            <div className="text-2xl md:text-3xl font-bold text-brandOrange mb-0.5" data-id="element-366">
              6
            </div>
            <div className="text-xs text-gray-300 font-medium" data-id="element-367">
              Tomos listos
            </div>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-368">
            <div className="text-2xl md:text-3xl font-bold text-brandOrange mb-0.5" data-id="element-369">
              6
            </div>
            <div className="text-xs text-gray-300 font-medium" data-id="element-370">
              Bonos incluidos
            </div>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-371">
            <div className="text-2xl md:text-3xl font-bold text-brandOrange mb-0.5" data-id="element-372">
              4.9/5
            </div>
            <div className="text-xs text-gray-300 font-medium flex items-center justify-center gap-1" data-id="element-373">
              calificación{' '}
              <Star size={12} className="fill-yellow-400 text-yellow-400" data-id="element-374" />
            </div>
          </FadeIn>
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'MR',
    text: 'Llegué al lunes con todo listo. Los juegos sin materiales me salvaron.',
    author: 'Marcelo R., Buenos Aires',
    role: 'Profe de Ed. Física'
  }, {
    initials: 'CP',
    text: '40 chicos y poco espacio. El bono de Espacios Chicos lo resolvió.',
    author: 'Carolina P., Córdoba',
    role: 'Escuela Primaria'
  }, {
    initials: 'DG',
    text: 'Domingo a la noche: 10 minutos y la clase del lunes lista.',
    author: 'Diego G., Rosario',
    role: 'Secundaria Técnica'
  }];
  return <div className="bg-[#060f1c] py-6 md:py-8 px-4" data-id="element-375">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-376">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-377">
            <div className="bg-[#0c1626] p-3 md:p-4 rounded-xl border border-white/10 h-full flex flex-col" data-id="element-378">
              <div className="flex items-center gap-2.5 mb-2" data-id="element-379">
                <div className="w-8 h-8 md:w-9 md:h-9 bg-brandOrange text-white rounded-full flex items-center justify-center font-bold text-[11px] md:text-xs shrink-0" data-id="element-380">
                  {t.initials}
                </div>
                <div className="min-w-0 flex-1" data-id="element-381">
                  <div className="flex text-yellow-400 mb-0.5" data-id="element-382">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-383" />)}
                  </div>
                  <p className="font-bold text-white text-[11px] md:text-xs leading-tight truncate" data-id="element-384">
                    {t.author}
                  </p>
                  <p className="text-[10px] text-gray-400 truncate" data-id="element-385">{t.role}</p>
                </div>
              </div>
              <p className="text-gray-300 text-[12px] md:text-[13px] italic leading-snug flex-grow" data-id="element-386">
                "{t.text}"
              </p>
            </div>
          </FadeIn>)}
      </div>
    </div>;
};
export const Problem = () => {
  const painPoints = ['Domingos buscando juegos en YouTube que no encajan', 'Clases armadas a las corridas la noche anterior', 'Siempre los mismos juegos, sin un banco real', 'Día de lluvia sin plan B y el grupo descontrolado', 'Grupos grandes, poco espacio, sin saber qué hacer', 'Alumnos de secundaria que se aburren y no participan'];
  return <Section className="bg-[#070f1e] text-white" data-id="element-387">
      <div className="max-w-3xl mx-auto" data-id="element-388">
        <FadeIn data-id="element-389">
          <h2 className="text-2xl md:text-5xl font-extrabold text-center mb-6 md:mb-10 uppercase tracking-tight md:tracking-wide text-white leading-[1.15]" data-id="element-390">
            Seguramente esto{' '}
            <span className="text-brandOrange" data-id="element-391">también te pasa...</span>
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10 md:mb-14" data-id="element-392">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-white/5 border border-white/10 rounded-xl md:rounded-2xl p-2.5 md:p-4 hover:bg-white/[0.07] transition-colors" data-id="element-393">
                <XCircle className="text-red-400 shrink-0 mt-0.5 md:mt-1 w-4 h-4 md:w-6 md:h-6" data-id="element-394" />
                <p className="text-gray-300 text-[13px] md:text-base leading-snug" data-id="element-395">
                  {point}
                </p>
              </div>)}
          </div>

          <h3 className="text-2xl md:text-4xl font-bold text-center text-white mb-6 md:mb-8" data-id="element-396">
            ¿Cuánto tiempo más vas a{' '}
            <span className="text-brandOrange" data-id="element-397">improvisar</span>?
          </h3>

          <div className="space-y-3 md:space-y-4 text-base md:text-lg text-gray-200 mb-10 md:mb-12 text-center md:text-left" data-id="element-398">
            <p data-id="element-399">
              Elegiste esta profesión porque amás el movimiento, el deporte y
              ver a tus alumnos crecer.
            </p>
            <p data-id="element-400">
              Pero nadie te dijo que ibas a perder los domingos buscando juegos
              que no encajan con tu grupo, armando clases a último momento y
              llegando el lunes improvisando algo que "más o menos sirve".
            </p>
          </div>

          <div className="bg-[#060f1c] border-2 border-brandOrange rounded-2xl md:rounded-3xl p-5 md:p-8 text-center" data-id="element-401">
            <p className="text-lg md:text-2xl font-extrabold uppercase tracking-wide text-white leading-tight" data-id="element-402">
              ¿Y si este fuera{' '}
              <span className="text-brandOrange" data-id="element-403">el último día</span> que pasás
              así?
            </p>
          </div>
        </FadeIn>
      </div>
    </Section>;
};